import httpClient from '../../utils/httpClient';
import { ApiSuccessResponse } from '../../utils/apiSchemas';
import { WgApplicationsEnum } from '../../utils/WgApplicationsEnum';

// Base route for Create Account / User Access endpoints
const USER_ACCESS_BASE_ROUTE = '/api/v1/portal/enrollment';

export interface RegisterNewCustomerPayload {
  userName: string;
  emailAddress: string;
  password: string;
  responsableName: string;
  responsableEmail: string;
  applications: WgApplicationsEnum[];
  legalName?: string;
  fantasyName?: string;
  registrationId?: string;
  language?: string;
  countryCode?: string;
  userAccessLocale?: string;
  registrationName?: string;
  customerCountry?: string;
  locale?: string;
  countryCustomer?: string;
}

export type RegisterNewCustomerResponse = string | null;

export const registerUserAccessAsNewCustomer = async (
  payload: RegisterNewCustomerPayload
): Promise<ApiSuccessResponse<RegisterNewCustomerResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<RegisterNewCustomerResponse>>(
    `${USER_ACCESS_BASE_ROUTE}/register`,
    payload
  );
  return response.data;
};
